// Offer selector (radiogroup), receipt, buy link, gallery, sticky bar, one-open FAQ.
(function () {
  var SHOP = '';
  var fmt = function (n) { return n.toLocaleString('en-US') + ' د.ع'; };
  var offers = [].slice.call(document.querySelectorAll('.offer'));
  var label = { 1: 'قطعة واحدة', 2: 'قطعتين', 3: '3 قطع' };

  function select(el, focus) {
    offers.forEach(function (o) {
      var on = o === el;
      o.classList.toggle('on', on);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
      o.tabIndex = on ? 0 : -1;
    });
    if (focus) el.focus();
    var qty = +el.dataset.qty, price = +el.dataset.price, full = +el.dataset.full;
    document.querySelector('[data-r-label]').textContent = label[qty];
    document.querySelector('[data-r-full]').textContent = fmt(full);
    var save = document.querySelector('[data-r-save]');
    save.textContent = full > price ? '−' + fmt(full - price) : '—';
    save.parentNode.style.display = full > price ? '' : 'none';
    document.querySelector('[data-r-total]').textContent = fmt(price);
    document.querySelector('[data-btn-price]').textContent = fmt(price);
    document.querySelector('[data-sticky-price]').textContent = fmt(price) + ' · ' + label[qty];
    document.dispatchEvent(new CustomEvent('gwa:offer'));
  }
  offers.forEach(function (o, i) {
    o.addEventListener('click', function () { select(o); });
    o.addEventListener('keydown', function (e) {
      var k = e.key, next = null;
      if (k === 'ArrowDown' || k === 'ArrowLeft') next = offers[(i + 1) % offers.length];
      if (k === 'ArrowUp' || k === 'ArrowRight') next = offers[(i - 1 + offers.length) % offers.length];
      if (k === ' ' || k === 'Enter') { e.preventDefault(); select(o); }
      if (next) { e.preventDefault(); select(next, true); }
    });
  });

  // Gallery
  var main = document.getElementById('gMain');
  [].slice.call(document.querySelectorAll('.g-thumbs button')).forEach(function (b, _, all) {
    b.addEventListener('click', function () {
      main.src = b.dataset.src;
      all.forEach(function (x) { x.classList.toggle('on', x === b); });
    });
  });

  // FAQ: one answer open at a time
  var ds = [].slice.call(document.querySelectorAll('.faq details'));
  ds.forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) ds.forEach(function (x) { if (x !== d) x.open = false; }); });
  });

  // Sticky CTA: show after the hero, hide while the buy block is on screen
  var sticky = document.getElementById('sticky'), hero = document.querySelector('.hero'), buy = document.getElementById('order');
  var heroOut = false, buyIn = false;
  var upd = function () { var on = true; /* always visible on the whole page */ sticky.classList.toggle('on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); };
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { heroOut = !e[0].isIntersecting; upd(); }).observe(hero);
    new IntersectionObserver(function (e) { buyIn = e[0].isIntersecting; upd(); }, { threshold: 0.15 }).observe(buy);
  }
})();
// Instagram comments rail arrows
(function () {
  var r = document.getElementById('igrail');
  [].slice.call(document.querySelectorAll('[data-ig]')).forEach(function (b) {
    b.addEventListener('click', function () { r.scrollBy({ left: +b.dataset.ig * r.clientWidth * 0.8, behavior: 'smooth' }); });
  });
})();

// Cash-on-delivery order form: same Worker, validation, lost-order drafts and Purchase event as /pages/nasal-aspirator.
(function () {
  var ENDPOINT = 'https://sk-pharmacy-order.saifgomaa48.workers.dev/order';
  var LEAD = ENDPOINT.replace(/\/order$/, '/lead');
  var f = document.getElementById('codf'); if (!f) return;
  var card = document.getElementById('codcard'), sub = document.getElementById('codSub'),
      alertBox = document.getElementById('codAlert'), btxt = sub.querySelector('.btxt'), btnHTML = btxt.innerHTML;
  function selected() { return document.querySelector('.offer.on') || document.querySelector('.offer'); }
  function bad(id, on) { document.getElementById(id).classList.toggle('bad', !!on); }
  function localPhone(v) {
    var d = (v || '').replace(/[^\d]/g, '');
    if (d.indexOf('00964') === 0) d = d.slice(5); else if (d.indexOf('964') === 0) d = d.slice(3);
    if (d.charAt(0) === '7') d = '0' + d;
    return /^07[3-9]\d{8}$/.test(d) ? d : null;
  }
  // The second number travels in the order note so it reaches the order without changing the Worker.
  function noteText() {
    var p2 = localPhone(f.phone2.value), n = f.note.value.trim();
    return (p2 ? 'رقم موبايل ثاني: ' + p2 : '') + (p2 && n ? ' | ' : '') + n;
  }
  function payload() {
    return { name: f.name.value.trim(), phone: localPhone(f.phone.value), governorate: f.governorate.value,
      address: f.address.value.trim(), note: noteText(), variantId: selected().dataset.variant, company: f.company.value };
  }
  // Lost orders: once a valid phone is typed, the Worker keeps it as a Shopify draft.
  var leadSent = '', leadTimer = null, leadOff = false, leadDone = false;
  function pushLead(beacon) {
    if (leadOff) return;
    var p = payload(); if (!p.phone) return;
    var body = JSON.stringify(p); if (body === leadSent) return; leadSent = body;
    if (beacon && navigator.sendBeacon) { navigator.sendBeacon(LEAD, new Blob([body], { type: 'text/plain' })); return; }
    fetch(LEAD, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: body, keepalive: true }).catch(function () { leadSent = ''; });
  }
  function queueLead() { clearTimeout(leadTimer); leadTimer = setTimeout(pushLead, 2500); }
  f.addEventListener('input', queueLead); f.addEventListener('change', queueLead);
  document.addEventListener('gwa:offer', queueLead);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') { clearTimeout(leadTimer); pushLead(true); } });

  f.addEventListener('submit', function (e) {
    e.preventDefault();
    alertBox.style.display = 'none';
    var p = payload(), ok = true;
    bad('f-name', p.name.length < 3); if (p.name.length < 3) ok = false;
    bad('f-phone', !p.phone); if (!p.phone) ok = false;
    var p2raw = f.phone2.value.trim(), p2ok = !p2raw || !!localPhone(p2raw);
    bad('f-phone2', !p2ok); if (!p2ok) ok = false;
    bad('f-gov', !p.governorate); if (!p.governorate) ok = false;
    bad('f-addr', p.address.length < 10); if (p.address.length < 10) ok = false;
    bad('f-agree', !f.agree.checked); if (!f.agree.checked) ok = false;
    if (!ok) { var b = f.querySelector('.f.bad input, .f.bad select'); if (b) b.focus(); return; }
    clearTimeout(leadTimer); leadOff = true;
    sub.disabled = true; sub.classList.add('is-busy'); btxt.textContent = 'كاعد يرسل...';
    var offer = selected();
    fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(p) })
      .then(function (r) { return r.json().then(function (j) { return { s: r.status, j: j }; }); })
      .then(function (res) {
        if (res.j && res.j.ok) {
          document.getElementById('codNum').textContent = 'رقم الطلبية ' + res.j.order;
          card.classList.add('is-done'); leadDone = true;
          card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (window.gtag) gtag('event', 'purchase');
          if (window.fbq) fbq('track', 'Purchase', { value: +offer.dataset.price, currency: 'IQD' });
          return;
        }
        if (res.j && res.j.fields) Object.keys(res.j.fields).forEach(function (k) {
          var id = { name: 'f-name', phone: 'f-phone', governorate: 'f-gov', address: 'f-addr' }[k]; if (id) bad(id, true);
        });
        alertBox.textContent = (res.j && res.j.message) || 'ما انرسلت الطلبية. راجعوا معلوماتكم وحاولوا مرة ثانية.';
        alertBox.style.display = 'block'; alertBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      })
      .catch(function () { alertBox.textContent = 'ماكو انترنيت. تأكدوا من الاتصال وحاولوا مرة ثانية.'; alertBox.style.display = 'block'; })
      .finally(function () {
        if (!leadDone) { leadOff = false; leadSent = ''; pushLead(); }
        sub.disabled = false; sub.classList.remove('is-busy'); btxt.innerHTML = btnHTML;
        var pr = document.querySelector('[data-btn-price]'), o = selected();
        if (pr && o) pr.textContent = (+o.dataset.price).toLocaleString('en-US') + ' د.ع';
      });
  });
})();

// Every "order now" button scrolls straight to the start of the order form (below the sticky header).
(function () {
  var card = document.getElementById('codcard'); if (!card) return;
  [].slice.call(document.querySelectorAll('a[href="#codcard"]')).forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var head = document.querySelector('.head'), off = (head ? head.offsetHeight : 64) + 10;
      var top = card.getBoundingClientRect().top + window.pageYOffset - off;
      var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
    });
  });
})();
